export const FALLBACK_PERSONA_OPTIONS = ["General Persona"];

export const resolveDefaultPersonaOptions = (customerUiInfo) =>
    customerUiInfo?.defaultPersonaOptions ?? FALLBACK_PERSONA_OPTIONS;

const TRUST_ENGINE_TEST_EMAIL = "trustengine@yopmail.com";
const DEFAULT_MAX_PERSONAS = 3;
const TRUST_ENGINE_MAX_PERSONAS = 5;

// Test account gets a hardcoded persona cap, bumped up from the default limit.
export const resolveMaxPersonas = (userEmail) =>
    userEmail?.toLowerCase() === TRUST_ENGINE_TEST_EMAIL
        ? TRUST_ENGINE_MAX_PERSONAS
        : DEFAULT_MAX_PERSONAS;
